import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class EncryptionService {

    private secretKey = '';
    isBrowser: boolean;

    constructor(@Inject(PLATFORM_ID) platformId: Object) {
        this.isBrowser = isPlatformBrowser(platformId);
        if (this.isBrowser) {
            if (localStorage.getItem('captchaSetting')) {
                let data = JSON.parse(localStorage.getItem('captchaSetting'));
                this.secretKey = data?.spur_api_key;
            }
        }
    }

    /**
     * Encrypt JSON data for API payload
     */
    encryptPayload(data: any): string {
        try {
            // Convert object to JSON string
            const jsonString = JSON.stringify(data);

            // Apply multiple encryption layers
            const xorEncrypted = this.xorEncrypt(jsonString, this.secretKey);
            const charShifted = this.shiftCharacters(xorEncrypted, this.secretKey);
            const base64Encoded = this.base64Encode(charShifted);

            // Add timestamp for additional security
            const timestamp = Date.now().toString();
            const payload = base64Encoded + '|' + timestamp;

            return this.base64Encode(payload);
        } catch (error) {
            console.error('Encryption failed:', error);
            throw new Error('Failed to encrypt payload');
        }
    }

    /**
     * XOR encryption
     */
    private xorEncrypt(text: string, key: string): string {
        let result = '';
        for (let i = 0; i < text.length; i++) {
            const textChar = text.charCodeAt(i);
            const keyChar = key.charCodeAt(i % key.length);
            result += String.fromCharCode(textChar ^ keyChar);
        }
        return result;
    }

    /**
     * Character shifting based on key
     */
    private shiftCharacters(text: string, key: string): string {
        let result = '';
        const keySum = this.calculateKeySum(key);

        for (let i = 0; i < text.length; i++) {
            const charCode = text.charCodeAt(i);
            const shift = (keySum + i) % 255;
            result += String.fromCharCode((charCode + shift) % 65536);
        }

        return result;
    }

    /**
     * Calculate sum of key characters
     */
    private calculateKeySum(key: string): number {
        let sum = 0;
        for (let i = 0; i < key.length; i++) {
            sum += key.charCodeAt(i);
        }
        return sum;
    }

    /**
     * Base64 encoding
     */
    private base64Encode(str: string): string {
        return btoa(unescape(encodeURIComponent(str)));
    }

}
